module.exports = [{
      plugin: require('/var/www/html/projets/dev/githubp/blog/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/var/www/html/projets/dev/githubp/blog/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    }]
